<script>
    import { getArtworkURL } from "../utils.js";

    export let album;
    export let artSize = 40;

    const music = MusicKit.getInstance();

    $: attrs = album.attributes;
    $: explicit = (attrs.contentRating == "explicit");
    $: artworkUrl = attrs && getArtworkURL(album, artSize, artSize) || '/missing-artwork.svg';
</script>

<div class="root" on:click>
    <div class="normal item">
        <img class="art"
             src="{artworkUrl}"
             alt="{attrs.artistName} - {attrs.albumName}"
             style="--size: {artSize}px">
        <div class="desc">
            <div class="name-line" style="--template-columns: {explicit ? "auto min-content 1fr" : "auto 1fr"}">
                <div class="name" title="{attrs.name}">{attrs.name}</div>
                {#if explicit}
                    <div class="explicit" title="Explicit song">E</div>
                {/if}
            </div>
            <div class="artist-album" title="{attrs.artistName}">
                {attrs.artistName}
            </div>
        </div>
        <div class="count">{album.songs.length} songs</div>
    </div>
</div>

<style>
    .root {
        position: relative;
    }

    .item {
        display: grid;
        grid-gap: 10px;
        grid-template-rows: 1fr;
        padding: var(--song-item-padding, 10px);
        color: var(--song-item-fg-color, var(--song-fg-color, var(--app-fg-color)));
        background-color: var(--song-item-bg-color, transparent);
        border-radius: var(--song-item-border-radius, 5px);
        cursor: pointer;
    }

    .item:hover {
        color: var(--song-item-hover-fg-color, var(--app-bg-color));
        background-color: var(--song-item-hover-bg-color, var(--app-fg-color));
    }

    .item:hover .count {
        color: var(--song-item-hover-secondary-fg-color, var(--app-secondary-bg-color));
    }

    .art {
        grid-area: item-art;
        border-radius: 5px;
    }

    .track-number {
        grid-area: track-number;
        color: var(--app-secondary-fg-color);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: var(--song-item-secondary-fg-color, var(--app-secondary-fg-color));
    }

    .item:hover .track-number {
        color: var(--song-item-hover-secondary-fg-color, var(--app-secondary-bg-color));
    }

    .desc {
        grid-area: desc;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        align-items: flex-start;
        justify-content: space-evenly;
        flex-direction: column;
    }

    .name-line {
        grid-area: song-name;
        display: grid;
        grid-template-rows: 1fr;
        grid-template-columns: var(--template-columns);
        grid-gap: 5px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .name,
    .artist-album {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .name-line,
    .artist-album {
        width: 100%;
    }

    .name {
        font-weight: bold;
    }

    .artist-album {
        font-size: 12px;
        color: var(--song-item-secondary-fg-color, var(--app-secondary-fg-color));
    }

    .item:hover .artist-album {
        color: var(--song-item-hover-secondary-fg-color, var(--app-secondary-bg-color));
    }

    .explicit {
        font-size: 15px;
        font-weight: bold;
        color: var(--song-item-explicit-fg-color, var(--app-explicit-fg-color));
        background-color: var(--song-item-explicit-bg-color, var(--app-explicit-bg-color));
        border-radius: 2px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
        padding: 0 5px;
        margin-left: 5px;
    }

    .count {
        grid-area: duration;
        color: var(--song-item-secondary-fg-color, var(--app-secondary-fg-color));
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .normal.item {
        grid-template-columns: min-content 1fr min-content;
        grid-template-areas: "item-art desc duration";
    }

    .normal .art {
        width: var(--size);
        height: var(--size);
    }
</style>
